var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlyfooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1620.99 217.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m319.84,28.6c-50.8,0-84.73,32.12-84.73,80.18s33.93,80.18,84.73,80.18,84.95-32.12,84.95-80.18-33.93-80.18-84.95-80.18Zm0,135.75c-33.71,0-56.71-22.31-56.71-55.57s23-55.57,56.71-55.57,56.71,22.31,56.71,55.57-22.78,55.57-56.71,55.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m542.6,31.36v112.28l-86.32-112.28h-34.6v154.85h26.41V62.31l95.21,123.9h25.73V31.36h-26.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m621.45,162.54V31.36h-27.57v154.85h132.8v-23.67h-105.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m814.6,31.36l-46.92,58.97-46.92-58.97h-34.85l67.19,84.03v70.82h27.8v-70.82l67.19-84.03h-33.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m893.64,155.71V31.36h-35.52v154.85h120.62l14.9-30.5h-100.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1099.54,31.36h-36.42l-68.56,154.85h37.11l13.89-32.79h69.93l13.91,32.79h38.7l-68.56-154.85Zm-41.43,92.46l22.53-56.26,22.33,56.26h-44.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1257.45,31.36l-39.4,52.61-39.64-52.61h-44.41l65.13,85.4v69.45h35.77v-69.45l65.13-85.4h-42.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1451.5,61.86v-30.5h-140.07v154.85h140.07v-30.5h-104.55v-32.12h89.75v-30.53h-89.75v-31.2h104.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1580.23,126.54c21.86-5.91,33.24-21.64,33.24-46.23,0-31.89-19.35-48.96-55.34-48.96h-92.23v154.85h35.52V61.86h52.83c15.72,0,23.03,5.94,23.03,18.46s-7.3,18.46-23.03,18.46h-34.25l20.59,30.5,38.5,56.93h41.9l-40.76-59.67Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "209.26 130.89 122.58 217.56 122.58 152.14 209.25 65.46 209.26 130.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "76.32 198.37 0 198.37 0 152.1 122.58 152.1 76.32 198.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "132.94 19.19 209.26 19.19 209.26 65.46 86.68 65.46 132.94 19.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 86.68 86.68 0 86.68 65.43 0 152.1 0 86.68"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlyfooter);
export default __webpack_public_path__ + "static/media/onlyfooter.fef7d0c1c824c3655b35e3746b5d83ec.svg";
export { ForwardRef as ReactComponent };